import {AnyEvent, USER_SIGNED_IN_EVENT, UserSignedInEvent} from '../type';

export default function userSignedIn(payload: UserSignedInEvent['payload']): AnyEvent {
  return {
    type: USER_SIGNED_IN_EVENT,
    payload,
  }
}
